import { KeyLabel, MOD } from './KeyLabel';

export const KeyLabelBepo: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
    meta: [
      {
        label: 'Æ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 5,
    label: 'K',
    meta: [
      {
        label: '~',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '⌨',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 6,
    label: 'X',
    meta: [
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '’',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'I',
    meta: [
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˙ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'P',
    meta: [
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '§',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'E',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¤ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 10,
    label: ',',
    meta: [
      {
        label: ';',
        modifiers: MOD.SFT,
      },
      {
        label: ';',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '̛  (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 11,
    label: 'C',
    meta: [
      {
        label: '©',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'ſ',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'ſ',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 12,
    label: 'D',
    meta: [
      {
        label: 'Ð',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 13,
    label: 'T',
    meta: [
      {
        label: 'Þ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 14,
    label: 'S',
    meta: [
      {
        label: 'ẞ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 15,
    label: 'R',
    meta: [
      {
        label: '®',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '™',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '™',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 16,
    label: 'Q',
    meta: [
      {
        label: '° (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '̣  (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '̣  (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 17,
    label: "'",
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '̉  (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '̉  (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 18,
    label: 'L',
    meta: [
      {
        label: '/ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 19,
    label: 'J',
    meta: [
      {
        label: 'Ĳ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 20,
    label: 'B',
    meta: [
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¦',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¦',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 21,
    label: 'O',
    meta: [
      {
        label: 'Œ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 22,
    label: 'U',
    meta: [
      {
        label: 'Ù',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'È',
    meta: [
      {
        label: '` (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 24,
    label: 'V',
    meta: [
      {
        label: 'ˇ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 25,
    label: '.',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '…',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '·',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '·',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 26,
    label: 'É',
    meta: [
      {
        label: '´ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˝ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˝ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 27,
    label: 'Y',
    meta: [
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‘',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‘',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 28,
    label: '^ (dead)',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¡',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 29,
    label: 'À',
    meta: [
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: '"',
    meta: [
      {
        label: '1',
        modifiers: MOD.SFT,
      },
      {
        label: '1',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '—',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '„',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '„',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: '«',
    meta: [
      {
        label: '2',
        modifiers: MOD.SFT,
      },
      {
        label: '2',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '“',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '“',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '»',
    meta: [
      {
        label: '3',
        modifiers: MOD.SFT,
      },
      {
        label: '3',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '”',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '”',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: '(',
    meta: [
      {
        label: '4',
        modifiers: MOD.SFT,
      },
      {
        label: '4',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '≤',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '≤',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: ')',
    meta: [
      {
        label: '5',
        modifiers: MOD.SFT,
      },
      {
        label: '5',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '≥',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '≥',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: '@',
    meta: [
      {
        label: '6',
        modifiers: MOD.SFT,
      },
      {
        label: '6',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '^',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '+',
    meta: [
      {
        label: '7',
        modifiers: MOD.SFT,
      },
      {
        label: '7',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '±',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¬',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¬',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '-',
    meta: [
      {
        label: '8',
        modifiers: MOD.SFT,
      },
      {
        label: '8',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '−',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¼',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¼',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '/',
    meta: [
      {
        label: '9',
        modifiers: MOD.SFT,
      },
      {
        label: '9',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '÷',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '½',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '½',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: '*',
    meta: [
      {
        label: '0',
        modifiers: MOD.SFT,
      },
      {
        label: '0',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '×',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¾',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¾',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: '=',
    meta: [
      {
        label: '°',
        modifiers: MOD.SFT,
      },
      {
        label: '°',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '≠',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '′',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '′',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '%',
    meta: [
      {
        label: '`',
        modifiers: MOD.SFT,
      },
      {
        label: '`',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '‰',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '″',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '″',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: 'Z',
    meta: [
      {
        label: 'Ə',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: 'W',
    meta: [
      {
        label: '˘ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 49,
    label: 'Ç',
    meta: [
      {
        label: '¸ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: ', (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: ', (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: 'N',
    meta: [
      {
        label: '~ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 52,
    label: 'M',
    meta: [
      {
        label: '¯ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'º',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'º',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '$',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '–',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¶',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¶',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 54,
    label: 'G',
    meta: [
      {
        label: 'µ (dead Greek key)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: 'H',
    meta: [
      {
        label: '†',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‡',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '‡',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 56,
    label: 'F',
    meta: [
      {
        label: '˛ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'ª',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'ª',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 100,
    label: 'Ê',
  },
  {
    code: 522,
    label: ';',
  },
  {
    code: 529,
    label: '?',
  },
  {
    code: 537,
    label: ':',
  },
  {
    code: 540,
    label: '!',
  },
  {
    code: 542,
    label: '1',
  },
  {
    code: 543,
    label: '2',
  },
  {
    code: 544,
    label: '3',
  },
  {
    code: 545,
    label: '4',
  },
  {
    code: 546,
    label: '5',
  },
  {
    code: 547,
    label: '6',
  },
  {
    code: 548,
    label: '7',
  },
  {
    code: 549,
    label: '8',
  },
  {
    code: 550,
    label: '9',
  },
  {
    code: 551,
    label: '0',
  },
  {
    code: 556,
    label: '(non-breaking space)',
  },
  {
    code: 557,
    label: '°',
  },
  {
    code: 558,
    label: '`',
  },
  {
    code: 565,
    label: '#',
  },
  {
    code: 4618,
    label: ';',
  },
  {
    code: 4625,
    label: '?',
  },
  {
    code: 4633,
    label: ':',
  },
  {
    code: 4636,
    label: '!',
  },
  {
    code: 4638,
    label: '1',
  },
  {
    code: 4639,
    label: '2',
  },
  {
    code: 4640,
    label: '3',
  },
  {
    code: 4641,
    label: '4',
  },
  {
    code: 4642,
    label: '5',
  },
  {
    code: 4643,
    label: '6',
  },
  {
    code: 4644,
    label: '7',
  },
  {
    code: 4645,
    label: '8',
  },
  {
    code: 4646,
    label: '9',
  },
  {
    code: 4647,
    label: '0',
  },
  {
    code: 4652,
    label: '(non-breaking space)',
  },
  {
    code: 4653,
    label: '°',
  },
  {
    code: 4654,
    label: '`',
  },
  {
    code: 4661,
    label: '#',
  },
  {
    code: 5120,
    label: '¿',
  },
  {
    code: 5124,
    label: 'Æ',
  },
  {
    code: 5125,
    label: '~',
  },
  {
    code: 5126,
    label: '}',
  },
  {
    code: 5127,
    label: '¨ (dead)',
  },
  {
    code: 5128,
    label: '&',
  },
  {
    code: 5129,
    label: '€',
  },
  {
    code: 5131,
    label: '©',
  },
  {
    code: 5132,
    label: 'Ð',
  },
  {
    code: 5133,
    label: 'Þ',
  },
  {
    code: 5134,
    label: 'ẞ',
  },
  {
    code: 5135,
    label: '®',
  },
  {
    code: 5136,
    label: '° (dead)',
  },
  {
    code: 5138,
    label: '/ (dead)',
  },
  {
    code: 5139,
    label: 'Ĳ',
  },
  {
    code: 5140,
    label: '|',
  },
  {
    code: 5141,
    label: 'Œ',
  },
  {
    code: 5142,
    label: 'Ù',
  },
  {
    code: 5143,
    label: '` (dead)',
  },
  {
    code: 5144,
    label: 'ˇ (dead)',
  },
  {
    code: 5145,
    label: '…',
  },
  {
    code: 5146,
    label: '´ (dead)',
  },
  {
    code: 5147,
    label: '{',
  },
  {
    code: 5148,
    label: '¡',
  },
  {
    code: 5149,
    label: '(backslash)',
  },
  {
    code: 5150,
    label: '—',
  },
  {
    code: 5151,
    label: '<',
  },
  {
    code: 5152,
    label: '>',
  },
  {
    code: 5153,
    label: '[',
  },
  {
    code: 5154,
    label: ']',
  },
  {
    code: 5155,
    label: '^',
  },
  {
    code: 5156,
    label: '±',
  },
  {
    code: 5157,
    label: '−',
  },
  {
    code: 5158,
    label: '÷',
  },
  {
    code: 5159,
    label: '×',
  },
  {
    code: 5164,
    label: '_',
  },
  {
    code: 5165,
    label: '≠',
  },
  {
    code: 5166,
    label: '‰',
  },
  {
    code: 5167,
    label: 'Ə',
  },
  {
    code: 5168,
    label: '˘ (dead)',
  },
  {
    code: 5169,
    label: '¸ (dead)',
  },
  {
    code: 5171,
    label: '~ (dead)',
  },
  {
    code: 5172,
    label: '¯ (dead)',
  },
  {
    code: 5173,
    label: '–',
  },
  {
    code: 5174,
    label: 'µ (dead Greek key)',
  },
  {
    code: 5175,
    label: '†',
  },
  {
    code: 5176,
    label: '˛ (dead)',
  },
  {
    code: 5632,
    label: '(narrow non-breaking space)',
  },
  {
    code: 5632,
    label: '(narrow non-breaking space)',
  },
  {
    code: 5637,
    label: '⌨',
  },
  {
    code: 5637,
    label: '⌨',
  },
  {
    code: 5638,
    label: '’',
  },
  {
    code: 5638,
    label: '’',
  },
  {
    code: 5639,
    label: '˙ (dead)',
  },
  {
    code: 5639,
    label: '˙ (dead)',
  },
  {
    code: 5640,
    label: '§',
  },
  {
    code: 5640,
    label: '§',
  },
  {
    code: 5641,
    label: '¤ (dead)',
  },
  {
    code: 5641,
    label: '¤ (dead)',
  },
  {
    code: 5642,
    label: '̛  (dead)',
  },
  {
    code: 5642,
    label: '̛  (dead)',
  },
  {
    code: 5643,
    label: 'ſ',
  },
  {
    code: 5643,
    label: 'ſ',
  },
  {
    code: 5647,
    label: '™',
  },
  {
    code: 5647,
    label: '™',
  },
  {
    code: 5648,
    label: '̣  (dead)',
  },
  {
    code: 5648,
    label: '̣  (dead)',
  },
  {
    code: 5649,
    label: '̉  (dead)',
  },
  {
    code: 5649,
    label: '̉  (dead)',
  },
  {
    code: 5652,
    label: '¦',
  },
  {
    code: 5652,
    label: '¦',
  },
  {
    code: 5657,
    label: '·',
  },
  {
    code: 5657,
    label: '·',
  },
  {
    code: 5658,
    label: '˝ (dead)',
  },
  {
    code: 5658,
    label: '˝ (dead)',
  },
  {
    code: 5659,
    label: '‘',
  },
  {
    code: 5659,
    label: '‘',
  },
  {
    code: 5662,
    label: '„',
  },
  {
    code: 5662,
    label: '„',
  },
  {
    code: 5663,
    label: '“',
  },
  {
    code: 5663,
    label: '“',
  },
  {
    code: 5664,
    label: '”',
  },
  {
    code: 5664,
    label: '”',
  },
  {
    code: 5665,
    label: '≤',
  },
  {
    code: 5665,
    label: '≤',
  },
  {
    code: 5666,
    label: '≥',
  },
  {
    code: 5666,
    label: '≥',
  },
  {
    code: 5668,
    label: '¬',
  },
  {
    code: 5668,
    label: '¬',
  },
  {
    code: 5669,
    label: '¼',
  },
  {
    code: 5669,
    label: '¼',
  },
  {
    code: 5670,
    label: '½',
  },
  {
    code: 5670,
    label: '½',
  },
  {
    code: 5671,
    label: '¾',
  },
  {
    code: 5671,
    label: '¾',
  },
  {
    code: 5677,
    label: '′',
  },
  {
    code: 5677,
    label: '′',
  },
  {
    code: 5678,
    label: '″',
  },
  {
    code: 5678,
    label: '″',
  },
  {
    code: 5681,
    label: ', (dead)',
  },
  {
    code: 5681,
    label: ', (dead)',
  },
  {
    code: 5684,
    label: 'º',
  },
  {
    code: 5684,
    label: 'º',
  },
  {
    code: 5685,
    label: '¶',
  },
  {
    code: 5685,
    label: '¶',
  },
  {
    code: 5687,
    label: '‡',
  },
  {
    code: 5687,
    label: '‡',
  },
  {
    code: 5688,
    label: 'ª',
  },
  {
    code: 5688,
    label: 'ª',
  },
];
